import React from 'react';

const AboutStart = () => {
  return (
    <div className="aboutStart">
      <div className="aboutTitleDiv">
        <h1 className="aboutTitle">Sobre a Empresa:</h1>
        <div className="lineTitleAbout"></div>
      </div>
      <div className="aboutBox1">
        <h1>O que é a BitPin?</h1>
        <div className="aboutLine"></div>
        <p>
          A BitPin nasceu do sonho de dois amigos estudantes de programação que
          compartilham a paixão pela tecnologia e a visão de transformar o mundo
          digital. Juntos, combinamos nossas habilidades e conhecimentos para
          criar uma startup que se dedica a oferecer soluções de desenvolvimento
          web inovadoras e personalizadas.
        </p>
      </div>
      <div className="aboutBox2">
        <h1>Nosso Objetivo:</h1>
        <div className="aboutLine"></div>
        <p>
          Na BitPin, nossa visão é sermos líderes em inovação e qualidade no
          desenvolvimento web, empoderando empresas de todos os tamanhos a
          alcançar seu potencial máximo no mundo digital. Acreditamos que a
          tecnologia deve ser acessível e transformadora, proporcionando
          soluções que não apenas atendam, mas superem as expectativas de nossos
          clientes.
        </p>
      </div>
      <div className="aboutBox1">
        <h1>Quem a BitPin atende?</h1>
        <div className="aboutLine"></div>
        <p>
          A BitPin atende uma ampla gama de clientes, desde pequenas e médias
          empresas que buscam uma presença institucional sólida na web até
          grandes organizações que necessitam de sistemas web personalizados
          para otimizar seus processos internos. Também atendemos pessoas
          físicas que desejam criar sites pessoais ou blogs que reflitam sua
          identidade única. Além disso, criamos landing pages focadas em
          conversão para campanhas de marketing. Independentemente do tamanho do
          projeto, nosso compromisso é sempre entregar soluções que atendam às
          necessidades específicas de cada cliente, garantindo resultados
          eficazes e de alta qualidade.
        </p>
      </div>
    </div>
  );
};

export default AboutStart;
